import {useState} from 'react';

const useToggle = (defaultValue = true): [boolean, (boolean?) => void] => {
  const [toggleValue, setToggle] = useState(defaultValue);
  const toggleHandler = (value: boolean) => {
    setToggle(value);
  };
  return [toggleValue, toggleHandler];
};

export default useToggle;
